import { render, staticRenderFns } from "./HuygensPrincipleViz.vue?vue&type=template&id=5d9683d1&scoped=true"
import script from "./HuygensPrincipleViz.vue?vue&type=script&lang=js"
export * from "./HuygensPrincipleViz.vue?vue&type=script&lang=js"
import style0 from "./HuygensPrincipleViz.vue?vue&type=style&index=0&id=5d9683d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9683d1",
  null
  
)

export default component.exports